import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, switchMap, take } from 'rxjs';
import { Language } from '@shared/interfaces';
import { selectUserLanguage } from '../store/user/user.selectors';
import { UserState } from '../store/user/user.state';
import { Store } from '@ngrx/store';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  constructor(private store: Store<UserState>) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.store.select(selectUserLanguage).pipe(
      take(1),
      switchMap(language => {
        const languageCode: Language = language?.description || 'ru-RU';

        const modifiedRequest = request.clone({
          setHeaders: {
            'Accept-Language': languageCode,
          },
        });

        return next.handle(modifiedRequest);
      }),
    );
  }
}
